import React from 'react';
import Icon from './Icon';
import './ErrorBanner.css';

const ErrorBanner = ({ errorType, errorMessage, onRetry = null, onClose = null }) => {
  const getErrorConfig = (errorType) => {
    switch (errorType) {
      case 'ValidationError':
        return {
          icon: 'AlertTriangle',
          color: 'var(--color-warning)',
          title: 'Erreur de validation',
          description: 'Les paramètres de l\'étude ne sont pas valides'
        };
      case 'AuthoritasApiError':
        return {
          icon: 'Cloud',
          color: 'var(--color-error)',
          title: 'Erreur du service d\'analyse',
          description: 'Impossible de récupérer les positions SERP'
        };
      case 'GoogleAdsApiError':
        return {
          icon: 'TrendingUp',
          color: 'var(--color-error)',
          title: 'Erreur de récupération des données',
          description: 'Impossible de récupérer les volumes de recherche'
        };
      case 'QuotaExceeded':
        return {
          icon: 'AlertCircle',
          color: 'var(--color-warning)',
          title: 'Quota dépassé',
          description: 'Limite d\'utilisation des API atteinte'
        };
      case 'NetworkTimeout':
        return {
          icon: 'Wifi',
          color: 'var(--color-gray-500)',
          title: 'Délai d\'attente dépassé',
          description: 'Les services externes ont mis trop de temps à répondre'
        };
      case 'DatabaseError':
        return {
          icon: 'Database',
          color: 'var(--color-error)',
          title: 'Erreur de base de données',
          description: 'Problème technique lors de l\'enregistrement des données'
        };
      case 'ComputationError':
        return {
          icon: 'Calculator',
          color: 'var(--color-error)',
          title: 'Erreur de calcul',
          description: 'Impossible de calculer les indicateurs de performance'
        };
      case 'MissingDataError':
        return {
          icon: 'FileX',
          color: 'var(--color-warning)',
          title: 'Données manquantes',
          description: 'Certaines données nécessaires à l\'analyse sont introuvables'
        };
      default:
        return {
          icon: 'AlertCircle',
          color: 'var(--color-error)',
          title: 'Erreur inconnue',
          description: 'Une erreur inattendue s\'est produite'
        };
    }
  };

  const config = getErrorConfig(errorType);

  return (
    <div className="error-banner" style={{ borderLeftColor: config.color }}>
      <div className="error-banner-content">
        <div className="error-banner-header">
          <div className="error-banner-icon" style={{ color: config.color }}>
            <Icon name={config.icon} size={20} />
          </div>
          <div className="error-banner-titles">
            <h4 className="error-banner-title">{config.title}</h4>
            <p className="error-banner-description">{config.description}</p>
          </div>
        </div>
        
        {errorMessage && (
          <div className="error-banner-details">
            <strong>Détails:</strong> {errorMessage}
          </div>
        )}
      </div>

      <div className="error-banner-actions">
        {onRetry && (
          <button 
            className="error-banner-btn error-banner-retry"
            onClick={onRetry}
            type="button"
          >
            <Icon name="RefreshCw" size={14} />
            Réessayer
          </button>
        )}
        {onClose && (
          <button 
            className="error-banner-btn error-banner-close"
            onClick={onClose}
            type="button"
          >
            <Icon name="X" size={14} />
          </button>
        )}
      </div>
    </div>
  );
};

export default ErrorBanner;